var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-gantt-footer"
  }, [_c('input', {
    staticClass: "scroll",
    attrs: {
      "type": "range",
      "min": _vm.startDate,
      "max": _vm.endDate,
      "step": _vm.step
    },
    domProps: {
      "value": _vm.period
    },
    on: {
      "input": function($event) {
        _vm.$emit('period-change', $event)
      }
    }
  }), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.scales[_vm.selected]
    },
    on: {
      "change": function($event) {
        _vm.$emit('scale-change', $event)
      }
    }
  }, _vm._l((_vm.scales), function(scale) {
    return _c('option', {
      key: scale,
      domProps: {
        "value": scale
      }
    }, [_vm._v(_vm._s(scale))])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ba0f11"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GanttFooter.vue
// module id = 202
// module chunks = 1